import React from 'react';
import Modal from '../modal';

const MapModal = props => {
   const { mapUrl, onClose } = props;
   console.log(mapUrl);
   return (
      <Modal onClose={onClose}>
         <iframe
            src={mapUrl}
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
         />
      </Modal>
   );
};

export default MapModal;



// WEBPACK FOOTER //
// ./src/components/About/mapModal.js